export default "__VITE_ASSET__ehmx4Wa4__"